import { BusEvent } from '@web/common';

export class AdminSubscriptionChangedBusEvent extends BusEvent {}
